import React, { useState, useEffect } from 'react';
import { Mail, Phone, MapPin, Send } from 'lucide-react';
import api from '../../services/api';
import './ContactPage.css';
import './LandingPage.css'; // Re-use variables
import { Link } from 'react-router-dom';
import tmsLogo from '../../assets/TmsLogoh.png';

const ContactPage = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const [submitting, setSubmitting] = useState(false);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.id]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        try {
            await api.post('/public/contact', formData);
            alert("Merci pour votre message ! Notre équipe reviendra vers vous rapidement.");
            setFormData({ name: '', email: '', subject: '', message: '' });
        } catch (error) {
            console.error('Error submitting contact form:', error);
            alert("Une erreur est survenue lors de l'envoi de votre message. Veuillez réessayer plus tard.");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="contact-page-wrapper">
            {/* Split Layout Container */}
            <div className="contact-split-container">

                {/* Left Side: Brand Info */}
                <div className="contact-brand-panel">
                    <div className="brand-panel-content">
                        <div className="brand-logo">
                            <Link to="/"><img src={tmsLogo} alt="Bfret Logo" /></Link>
                        </div>

                        <div className="brand-text-content">
                            <div className="contact-badge">Contactez-nous</div>
                            <h1 className="brand-title">Parlons de <span className="text-gradient">votre projet</span> logistique</h1>
                            <p className="brand-description">
                                Vous souhaitez automatiser vos transports ? Nos experts sont là pour vous accompagner dans votre transformation digitale.
                            </p>
                        </div>

                        {/*<div className="contact-info-links">
                            <div className="info-link-item">
                                <div className="info-icon"><Mail size={20} /></div>
                                <div className="info-text">
                                    <span className="info-label">Email</span>
                                    <span className="info-value">contact@xxxx.com</span>
                                </div>
                            </div>
                            <div className="info-link-item">
                                <div className="info-icon"><Phone size={20} /></div>
                                <div className="info-text">
                                    <span className="info-label">Téléphone</span>
                                    <span className="info-value">+212 (0) 555 00 00 00</span>
                                </div>
                            </div>
                            <div className="info-link-item">
                                <div className="info-icon"><MapPin size={20} /></div>
                                <div className="info-text">
                                    <span className="info-label">Adresse</span>
                                    <span className="info-value">Casablanca, Maroc</span>
                                </div>
                            </div>
                        </div>*/}
                    </div>

                    {/* Decorative background element */}
                    <div className="brand-panel-bg-curve"></div>
                </div>

                {/* Right Side: Form Area */}
                <div className="contact-form-panel">
                    <div className="form-card-container">
                        <div className="contact-form-card-v2">
                            <h2 className="form-title">Contactez-nous</h2>

                            <form onSubmit={handleSubmit} className="premium-form">
                                <div className="form-row">
                                    <div className="form-group-v2">
                                        <label htmlFor="name">Nom complet</label>
                                        <input
                                            type="text"
                                            id="name"
                                            placeholder="Votre nom"
                                            required
                                            value={formData.name}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="form-group-v2">
                                        <label htmlFor="email">Email professionnel</label>
                                        <input
                                            type="email"
                                            id="email"
                                            placeholder="email@entreprise.com"
                                            required
                                            value={formData.email}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="form-group-v2">
                                        <label htmlFor="subject">Sujet</label>
                                        <select
                                            id="subject"
                                            value={formData.subject}
                                            onChange={handleChange}
                                            required
                                            className="premium-select"
                                        >
                                            <option value="" disabled>Sélectionnez un sujet</option>
                                            <option value="demo">Démo personnalisée</option>
                                            <option value="info">Informations générales</option>
                                            <option value="support">Support technique</option>
                                            <option value="partnership">Partenariat</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="form-group-v2">
                                        <label htmlFor="message">Message</label>
                                        <textarea
                                            id="message"
                                            rows="4"
                                            placeholder="Dites-nous en plus sur vos besoins..."
                                            required
                                            value={formData.message}
                                            onChange={handleChange}
                                        ></textarea>
                                    </div>
                                </div>

                                <button type="submit" className="btn-submit-v2" disabled={submitting}>
                                    {submitting ? 'Envoi en cours...' : 'Envoyer mon message'} <Send size={18} />
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactPage;
